
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Links from "../pages/links/page";
import Blog from "../pages/blog/page";
import Verification from "../pages/verification/page";
import Admin from "../pages/admin/page";
import Forum from "../pages/forum/page";
import PostDetail from '../pages/forum/components/PostDetail';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/verification",
    element: <Verification />,
  },
  {
    path: "/links",
    element: <Links />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: '/forum',
    element: <Forum />
  },
  {
    path: '/forum/:id',
    element: <PostDetail />
  }
];

export default routes;
